import { Percent } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { WA } from "../../lib/site";
import { WhatsAppIcon } from "./Icons";

export const CampaignBanner = () => {
  const { settings } = useSite();
  if (!settings.campaign_active || !settings.campaign_text) return null;
  return (
    <section data-testid="campaign-banner" className="container-lux py-6">
      <div className="bg-emerald-grad relative flex flex-col items-start gap-5 overflow-hidden rounded-3xl px-6 py-8 text-white sm:flex-row sm:items-center sm:justify-between sm:px-10">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full border border-gold/25" />
        <div className="pointer-events-none absolute -right-4 -top-4 h-32 w-32 rounded-full border border-gold/15" />
        <div className="relative flex items-center gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/50 text-gold-light">
            <Percent className="h-5 w-5" strokeWidth={1.8} />
          </span>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-gold-light/90">Kampanya</p>
            <p className="mt-1 text-lg font-semibold sm:text-xl" data-testid="campaign-text">{settings.campaign_text}</p>
          </div>
        </div>
        <a href={WA} target="_blank" rel="noopener noreferrer" className="btn-gold relative" data-testid="campaign-cta">
          <WhatsAppIcon className="h-4 w-4" /> Kampanyadan Yararlan
        </a>
      </div>
    </section>
  );
};
